import React, {useContext, useEffect} from 'react';
import Grid from "@mui/material/Grid";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {categoriesV2} from "../../../../utils/dictionaries/Categories";
import {MenuItem, TextField} from "@mui/material";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {bigNoteRegisterNotRequired, bigNoteRegisterRequired,} from "../../../../utils/RegisterUtils";
import {useForm, useFormContext} from "react-hook-form";
import { Autocomplete } from '@mui/material';
import {getCategoryByLabel, getSubcategoryByString} from "../../../../utils/GenericUtils";
import FileInput from "../../carico/utils/FileInput";
import {PaperComponent} from "../../../../styles/components/DynamicComponentStyle";
import {CategoriesContext} from "../../../../App";

export const InternalTicketDetails = ({mail = true, ticketSelected, tags, setTags, handleKeyDown, inoltra}) => {
    const {control, errors, watch, register, setValue, reset} = useFormContext();
    const categoriesContext = useContext(CategoriesContext);

    useEffect(() => {
        if (ticketSelected) {
            let cat = getCategoryByLabel(ticketSelected.categoria, categoriesContext.categoriesV3);
            reset({
                ...ticketSelected,
                categoria: cat,
                sottoCategoria: getSubcategoryByString(cat, ticketSelected.sottoCategoria)
            })
        }
    }, [ticketSelected, setValue, reset])

    const handleCreateTag = event => {
        switch (event.key) {
            case ",":
            case "Enter":
            case "\n":
            case "\t":
            case "Alt":
            case "Tab":
            case " ": {
                event.preventDefault();
                event.stopPropagation();
                if (event.target.value.length > 0) {
                    setTags([...tags, "#" + event.target.value?.toUpperCase()]);
                }
                break;
            }
            default:
        }
    };

    return (
        <React.Fragment>
            <Grid item xs={12} sm={mail ? 8 : 12}>
                <CustomSelect
                    name={"categoria"}
                    label={"Seleziona una categoria *"}
                    control={control}
                    defaultValue={""}
                    autoFocus={false}
                    none={true}
                    noneValue={""}
                    rules={{required: true}}
                    error={errors["categoria"]}
                >
                    {Object.entries(categoriesContext.categoriesV3)
                        .sort((a, b) => {
                            if (a["1"].label > b["1"].label) return 1;
                            if (a["1"].label < b["1"].label) return -1;
                            return 0
                        })
                        .map(([key, val]) => {
                            return (
                                <MenuItem value={val.label} key={val.label}>
                                    {val.label}
                                </MenuItem>
                            );
                        })}
                </CustomSelect>
            </Grid>
            {mail &&
                <React.Fragment>
                    <Grid item xs={12} sm={2} style={{display: "flex", alignItems: "center"}}>
                        <CustomSelect
                            name={"sendMail"}
                            label={"Invia mail"}
                            control={control}
                            defaultValue={false}
                            autoFocus={false}
                            rules={{required: false}}
                            error={errors["sendMail"]}
                            disabled={watch("email")?.length <= 0}
                            tooltip={true}
                            title={"Se decidi di inviare la mail il paziente potrà visualizzare ciò che gli è stato riposto, allegare elementi al ticket e rispondere ad esso. NB: La mail deve esistere e deve essere valida!"}
                        >
                            <MenuItem value={true}>
                                Sì
                            </MenuItem>
                            <MenuItem value={false}>
                                No
                            </MenuItem>
                        </CustomSelect>
                    </Grid>
                    <Grid item xs={12} sm={2} style={{display: "flex", alignItems: "center"}}>
                        <CustomSelect
                            name={"contattoMail"}
                            label={"Contatto via mail?"}
                            control={control}
                            defaultValue={false}
                            autoFocus={false}
                            rules={{required: false}}
                            error={errors["contattoMail"]}
                            disabled={watch("sendMail") !== true}
                            tooltip={true}
                            title={"Se al paziente va bene essere contattato via mail (tramite ticket Ocean). NB: La mail deve esistere e deve essere valida e devi spuntare invia mail!"}
                        >
                            <MenuItem value={true}>
                                Sì
                            </MenuItem>
                            <MenuItem value={false}>
                                No
                            </MenuItem>
                        </CustomSelect>
                    </Grid>
                </React.Fragment>
            }
            {
                watch("categoria") && getCategoryByLabel(watch("categoria"), categoriesContext.categoriesV3)?.subCategories?.length > 0 &&
                <Grid item xs={12}>
                    <CustomSelect
                        name={"sottoCategoria"}
                        label={"Quale di queste sotto categorie? *"}
                        control={control}
                        defaultValue={""}
                        autoFocus={false}
                        none={true}
                        noneValue={""}
                        rules={{required: true}}
                        error={errors["sottoCategoria"]}
                    >
                        {getCategoryByLabel(watch("categoria"), categoriesContext.categoriesV3).subCategories.filter(val => val.enabled).map((val, key) => {
                            return (
                                <MenuItem value={val.label} key={val.label}>
                                    {val.label}
                                </MenuItem>
                            );
                        })}
                    </CustomSelect>
                </Grid>
            }

            <Grid item xs={12}>
                <Autocomplete
                    multiple
                    freeSolo
                    options={[]}
                    getOptionLabel={option => option || option}
                    value={tags}
                    onChange={(event, newValue) => setTags(newValue)}
                    filterSelectedOptions
                    PaperComponent={PaperComponent}
                    renderInput={params => {
                        params.inputProps.onKeyDown = handleCreateTag;
                        return (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="TAG del ticket"
                                fullWidth
                            />
                        );
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <CustomMultiText
                    handleKeyDown={handleKeyDown}
                    inputRef={register(inoltra ? bigNoteRegisterNotRequired : bigNoteRegisterRequired)}
                    name={mail ? "dettaglioRichiesta" : "note"}
                    label={mail ? "Dettaglio del ticket *" : "Note*"}
                    autoFocus={false}
                    error={errors[mail ? "dettaglioRichiesta" : "note"]}
                    rows={10}
                />
            </Grid>

            {
                !mail &&
                <Grid item xs={12}>
                    <FileInput name={"allegati"} multiple={true} accept={"*"}/>
                </Grid>
            }
        </React.Fragment>
    );
};
